"use strict";

function readMoreButtonShowInvisibleAccordionElements(uniqueId) {

    const accordionParentElement = document.querySelector(`#${uniqueId}`);
    
    const allAccordionElements = accordionParentElement.querySelectorAll('.wp-block-acf-help-centre-posts-faq-accordion-picker__accordion[data-visible-start="false"]');
    const readMoreButton = accordionParentElement.querySelector('.js-see-more-accordions-button button');

    console.log('allAccordionElements', allAccordionElements)
    
    if (!allAccordionElements.length || !readMoreButton) return;
    const readMoreButtonText = readMoreButton.textContent;

    readMoreButton.addEventListener('click', (event) => {

        readMoreButton.classList.toggle('is-open');

    
        for (const accordion of allAccordionElements) {

            if (readMoreButton.classList.contains('is-open')) {
                
                accordion.style.visibility = 'visible';
                accordion.style.opacity = '1'
                accordion.style.height = 'auto';
                readMoreButton.textContent = "See less"
            } else {

                accordion.style.visibility = 'hidden';
                accordion.style.opacity = '0'
                accordion.style.height = '0';
                readMoreButton.textContent = readMoreButtonText
            }
            
        }

    })
}

function getAllFAQaccordions() {

    const allFAQaccordions = document.querySelectorAll('.wp-block-acf-help-centre-posts-faq-accordion-picker');
    if (!allFAQaccordions.length) return;

    for (const accordion of allFAQaccordions) { 

        const uniqueId = accordion.id;
        readMoreButtonShowInvisibleAccordionElements(uniqueId)
    }
}



document.addEventListener('DOMContentLoaded', () => { 
    // readMoreButtonShowInvisibleAccordionElements()
    getAllFAQaccordions()
})